// AidnRouteGuard — route-level feature gate for every /aidn/* route (defense-in-depth).
//
// Hiding the nav tab (separateMenu `featureGate`) stops discovery, but a disabled user can still
// type or bookmark a direct AIDN URL. Most AIDN views self-gate to <AidnUnavailableNotice/>, but
// several sub-routes (e.g. /aidn/create/wizard, /aidn/question-update) render views that do not.
// Wrapping each /aidn/* route element in this guard guarantees a disabled user who lands on ANY
// AIDN URL sees the same splash instead of the bare page.
//
// Gating: reuses useAidnFeatureGate → `enabled` = MASTER (GET /aidn/v1/feature/status),
// fail-closed. While the status loads we render a spinner; when disabled we render the splash (the
// same target as each view's own page gate); when enabled we render the wrapped route element.

import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@mui/material';
import AidnUnavailableNotice from './components/AidnUnavailableNotice';
import useAidnFeatureGate from './hooks/useAidnFeatureGate';

export default function AidnRouteGuard({ children }) {
  const { enabled, loading, reason } = useAidnFeatureGate();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }} data-testid="aidn-route-guard-loading">
        <CircularProgress />
      </Box>
    );
  }

  if (!enabled) {
    return <AidnUnavailableNotice reason={reason} />;
  }

  return children;
}

AidnRouteGuard.propTypes = {
  children: PropTypes.node
};
